module.exports = __webpack_public_path__ + "img/bm.8dfa1c84.svg";